import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

export const LICENSE_STATUS = {
  APPROVED: 'Approved',
  ATTENDED: 'Attended',
  NO_SHOW: 'No-Show',
  COMPLETED_PASS: 'Completed-Pass',
  COMPLETED_FAIL: 'Completed-Fail',
  CANCELLED: 'Cancelled',
  RETEST_SCHEDULED: 'Retest scheduled',

  // Additional license status for online course.
  NEW: 'New',
  ALLOCATED: 'Allocated',
};

const LICENSE_STATUS_TO_READABLE = {
  [LICENSE_STATUS.NEW]: globalTranslate('licenseStatus.new'),
  [LICENSE_STATUS.ALLOCATED]: globalTranslate('licenseStatus.allocated'),
  [LICENSE_STATUS.APPROVED]: globalTranslate('licenseStatus.approved'),
  [LICENSE_STATUS.ATTENDED]: globalTranslate('licenseStatus.attended'),
  [LICENSE_STATUS.NO_SHOW]: globalTranslate('licenseStatus.noShow'),
  [LICENSE_STATUS.COMPLETED_PASS]: globalTranslate('licenseStatus.completedPass'),
  [LICENSE_STATUS.COMPLETED_FAIL]: globalTranslate('licenseStatus.completedFail'),
  [LICENSE_STATUS.CANCELLED]: globalTranslate('licenseStatus.cancelled'),
  [LICENSE_STATUS.RETEST_SCHEDULED]: globalTranslate('licenseStatus.retestScheduled'),
};

export class LicenseStatus {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
  }

  /**
   * Map to readable
   * @param {LicenseStatus} licenseStatus License status.
   * @returns {string}
   */
  static toReadable(licenseStatus) {
    const readableStatus = LICENSE_STATUS_TO_READABLE[licenseStatus.name];
    return readableStatus ?? licenseStatus.name;
  }
}
